var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",staticStyle:{"display":"inline-block"}},[_c('img',{staticClass:"img",staticStyle:{"width":"0.15rem","position":"relative","top":"2px"},attrs:{"src":_vm.levelIcon,"alt":"等级"}}),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v(_vm._s(_vm.levelName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46be40a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userElement/components/MemberLevel.vue
// module id = null
// module chunks = 